import React from 'react'

import userDark from '../images/user-dark.png'

type Props = {}

const AdminSettings = (props: Props) => {
  return (
    <div className='settings-panel'>
          <div className='title'>
              ADMIN ROLE
          </div>
          <div className='info-panel'>
            <div className='header'>
              <div className='user'>
                <img src={userDark} alt='user' className='child'/>
                <label className='child'></label>User Role
              </div>
            </div>
          </div>
    </div>
  )
}

export default AdminSettings